import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../AppContext";
import { SendEmailAndCode } from "../../services/OnbordingService";

const ThankYouPage = () => {
  const { email, responseMessage } = useContext(AppContext);
  const navigate = useNavigate();  

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.hash.split('?')[1]);

    const firstname = queryParams.get("firstname") || "";
    const lastname = queryParams.get("lastname") || "";
    const businessName = queryParams.get("business_name") || "";
    const jotform_submission_id = queryParams.get("jotform_submission_id") || "";
    const phone_number = queryParams.get("phone_number") || "";
    
    const formatPhoneNumber = (phone) => {
      return phone.replace(/\D/g, ""); 
    };
    const payload = {
      email: email || "",
      code: responseMessage?.code || "",
      first_name: firstname,
      last_name: lastname,
      business_name: businessName,
      jotform_submission_id:jotform_submission_id,
      phone_number: formatPhoneNumber(phone_number),
    };

    const sendEmailAndCode = async () => {
      try {
        const response = await SendEmailAndCode(payload);
    
      } catch (error) {
        console.error("Error sending email and code:", error);
      }
    };

    sendEmailAndCode();
  }, [email, responseMessage]);

  const handleClick = () => {
    navigate('/');  
  
  };

  return (
    <div>
      <div className="bg-image d-flex justify-content-center align-items-center bannerThank">
        <div className="popupWht text-center">
          <h3>Thank you for submitting your T-Mobile <span className="inlineblk">Sub-Dealer</span> application.</h3>
          <p className="marB30">It is currently under review, and the process may take up to 5 business days within which our team will contact you directly to discuss next steps.</p>
          <a href="/" className="btn btn-sm btn-secondary secondaryBtn">
            RETURN TO HOME PAGE
          </a>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
